import type { ReactNode } from 'react'

type InputFakeProps = {
  value?: ReactNode
  prefix?: ReactNode
  suffix?: ReactNode
}

export const InputFake = ({ value, prefix, suffix }: InputFakeProps) => {
  return (
    <span className='flex min-h-11 gap-[10px] rounded-[12px] border-1 border-[#CDDDEE] px-[11px] transition-all hover:border-[#007AE1] active:border-[#007AE1]'>
      {prefix && <span className='flex h-11 items-center'>{prefix}</span>}
      <div className='flex w-full flex-col justify-center'>{value}</div>
      {suffix && <span className='flex h-11 items-center'>{suffix}</span>}
    </span>
  )
}
